import { isMobileDevice } from '@frontend/libs/utils'

import DesktopFooter from './components/DesktopFooter'
import MobileFooter from './components/MobileFooter'

function Footer() {
  if (isMobileDevice) {
    return <MobileFooter />
  }

  return <DesktopFooter />
}

export default Footer
